// extracted by mini-css-extract-plugin
export default {"container":"B0940_","interaction":"T4iAaA","heading":"pffykT","buttonWrapper":"Eq80qm","register":"cKgIXr","login":"QCplIq","button":"zzI3bE"};